import { convertNumberToStr } from '@/utils/api';
import dayjs from 'dayjs';
import { toFixedNoRound } from '@/utils/api';
import { useModuleData } from '@/rebuild/hooks/data/useModuleData';
import { convertPX } from '@/utils/echarts';

export function useMainBusinessData() {
	const { main_business } = useModuleData();

	const loadData = async ({ classifCd, reportType }) => {
		const params = {
			classifCd,
			reportType
		};
		await main_business.refresh(params);
		return main_business?.data?.data?.sort((a, b) => a?.reportDate - b?.reportDate) || [];

	};
	/**
	 *
	 * @param {*} list
	 * @param {*} type  1:数据 2:占比
	 * @param {*} timeType 0:all 3:近三年 5:近五年
	 * @param {*} period A:年度 S1:半年度
	 * @param {*} isMobile 是否是移动端
	 * @returns
	 */
	const getDataFunc = ({
		list,
		type,
		timeType,
		period,
		isMobile
	} = {
			list: [],
			type: 1,
			timeType: 0,
			period: 'A',
			isMobile: false
		}) => {
		if (!list || list.length === 0) {
			return {
				legends: [],
				seriesData: [],
				chartOptions: {
					legend: {
						data: []
					}
				}
			};
		}
		// list 是时间从大到小，需要根据时间类型进行切片，再3年或者5年
		// 获取最新一条数据的时间戳
		const latestDate = list[list.length - 1].reportDate;

		const threeYearAgo = latestDate - 3 * 365 * 24 * 60 * 60 * 1000;
		const fiveYearAgo = latestDate - 5 * 365 * 24 * 60 * 60 * 1000;
		if (timeType === 3) {
			list = list.filter(item => item.reportDate >= threeYearAgo);
		} else if (timeType === 5) {
			list = list.filter(item => item.reportDate >= fiveYearAgo);
		}


		// 收集所有地区名称，用于生成图例
		const allRegions = new Set();
		list.forEach(item => {
			item.stockMainBusinessVOList?.forEach(region => {
				allRegions.add(region.itemName);
			});
		});

		// 按地区分组数据
		const regionDataMap = new Map();
		allRegions.forEach(regionName => {
			regionDataMap.set(regionName, []);
		});

		// 填充每个地区的数据
		list.forEach(item => {
			const year = period === 'A' ? dayjs(item.reportDate).format('YYYY') : dayjs(item.reportDate).format('YYYY.MM.DD');
			item.stockMainBusinessVOList?.forEach(region => {
				const regionName = region.itemName;
				const value = type === 2 ? region.revenueIsPctge : region.revenue;
				let valueStr = value === 0 ? null : value;
				valueStr = type === 2 ? toFixedNoRound(valueStr) : valueStr;
				regionDataMap.get(regionName)?.push({
					name: year,
					value: valueStr,
					unit: type === 2 ? '%' : ''
				});

			});
		});

		// 生成 seriesData
		const seriesData = [];
		const legendData = [];
		const tableData = [];
		let dynamicColumns = [];

		regionDataMap.forEach((data, regionName) => {
			if (data.length > 0) {
				seriesData.push({
					name: regionName,
					type: 'bar',
					stack: 'a',
					data: data,
					barMaxWidth: convertPX(26),
				});
				legendData.push(regionName);

				// 处理表格数据
				const columnKeyValue = {};
				data.forEach(item => {
					dynamicColumns.push(item.name);
					const value = type === 2 ? item.value + '%' : convertNumberToStr(item.value);
					columnKeyValue[item.name] = value
				});
				tableData.push({
					...columnKeyValue,
					name: regionName,
					unit: type === 2 ? '%' : ''
				});
				dynamicColumns = data.map(item => item.name).reverse();
			}
		});
		const option = {
			seriesData: seriesData,
			chartOptions: {

				legend: {
					data: legendData,
					type: 'scroll',
					padding: [5, 20],
					show: isMobile ? false : true
				}
			},
			tooltip: {
				order: 'valueDesc'
			},
			legends: legendData,
			showToolTipAxisValue: true,
			tooltipFormatterOrder: 'desc'

		};

		return {
			chartOptions: option,
			tableOptions: {
				columns: dynamicColumns,
				data: tableData
			},

		}
	};
	return {
		loadData,
		getDataFunc,

	}
}
